(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.Limit) {
    return;
  }

  class Counter {
    /**
     * Initializes a new instance of the class.
     * @constructor
     * @property {number} max - The maximum value for the counter.
     * @property {boolean} loop - Indicates whether the counter should loop.
     * @property {number} start - The starting value of the counter.
     */
    constructor() {
      this.max = 0;
      this.loop = false;
      this.start = 0;
    }

    /**
     * Initializes the carousel counter with the specified parameters.
     *
     * @param {number} max - The maximum value for the counter.
     * @param {number} start - The starting value for the counter.
     * @param {boolean} loop - Whether the counter should loop when reaching the end.
     */
    initialize(max, start, loop) {
      this.max = max;
      this.loop = loop || false;
      this.start = start || 0;
      this.limit = new Carousel.Limit();
      this.limit.initialize(0, this.max);
      this.loopEnd = max + 1;
      this.counter = this.withinLimit(start);
    }

    /**
     * Returns a constrained number within the carousel's valid range.
     * If looping is disabled, constrains the number using the `constrain` method.
     * If looping is enabled, wraps the number within the loop boundaries.
     *
     * @param {number} number - The index or value to constrain or wrap.
     * @returns {number} The constrained or wrapped index/value.
     */
    withinLimit(number) {
      if (!this.loop) {
        return this.limit.constrain(number);
      }
      return Math.abs((this.loopEnd + number) % this.loopEnd);
    }

    /**
     * Returns the current value of the counter.
     * @returns {number} The current counter value.
     */
    get() {
      return this.counter;
    }

    /**
     * Sets the counter to the specified number, ensuring it is within allowed limits.
     * @param {number} number - The value to set the counter to.
     * @returns {this} The current instance for method chaining.
     */
    set(number) {
      this.counter = this.withinLimit(number);
      return this;
    }

    /**
     * Creates a new Counter instance with the same maximum value,
     * current value, and loop setting as the current instance.
     * @returns {Counter} A cloned Counter instance with identical properties.
     */
    clone() {
      const clone = new Counter();
      clone.initialize(this.max, this.get(), this.loop);
      return clone;
    }

    /**
     * Adds the specified number to the current value and returns a new instance with the updated value.
     *
     * @param {number} number - The number to add to the current value.
     * @returns {this} A new instance with the updated value.
     */
    add(number) {
      return this.clone().set(this.get() + number);
    }
  }

  global.NewHomeSource.Carousel.Counter = Counter;
}(window));
